import ActivatedContractTypePage, {
  ActivatedContractBenefitList,
} from "./ActivatedContractTypePage";
import { STANDARD_BENEFITS } from "./StandardCard";
import { ContractPath } from "../routing/ContractPath";
import { useRelativeUrls } from "../routing/ContractFormRoutes";
import { RelativeNavigationFooter } from "../RouterFooterLink";
import { Redirect } from "react-router";
import { TitleSection } from "../../formatting/CardSection";

export default function StandardContractPage({ page }: { page: ContractPath }) {
  const relativeUrls = useRelativeUrls(page);

  if (relativeUrls.redirect) return <Redirect to={relativeUrls.redirect} />;

  return (
    <ActivatedContractTypePage>
      <TitleSection title="Kontrakten er oppgradert til Standard">
        <p>I kontrakten har du tilgang til:</p>
        <ActivatedContractBenefitList benefits={STANDARD_BENEFITS} />
      </TitleSection>
      <RelativeNavigationFooter using={relativeUrls} />
    </ActivatedContractTypePage>
  );
}
